var rtl_default = {
  "rtl": "Hopyr",
  "ltr": "I-5lw"
};
export {
  rtl_default as default
};
//# sourceMappingURL=rtl-scss.js.map
